
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexL6IBblXwOeGe20PFY6CEA_XHd4mNKrrU5AlHwcK4aA4Meta } from "/opt/buildhome/repo/src/pages/index.vue?macro=true";
import { default as index2FtpexvyzCR_jxsFFz5u3XhooZijysjO8DpD1jDDDoYMeta } from "/opt/buildhome/repo/src/pages/org/index.vue?macro=true";
import { default as indexgNqYemAmWBNpVln1tbm4j13HGAY4e0owt2O6Jr5vbIEMeta } from "/opt/buildhome/repo/src/pages/org/new/index.vue?macro=true";
import { default as enter_45otpOI9x_45BBqYA3XkwV_yzRjg_FjQTsQndEKO78xghrQTlAMeta } from "/opt/buildhome/repo/src/pages/(auth)/enter-otp.vue?macro=true";
import { default as index7USUT2FsTWWZsQX4daVKdiby0TVI9ngKrVH_45zk0D3akMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/index.vue?macro=true";
import { default as enter_45emailq6r6TrDl_45BtMcy2jgG_45aYbyO8d2VjOWt2VZxERqZKKUMeta } from "/opt/buildhome/repo/src/pages/(auth)/enter-email.vue?macro=true";
import { default as welcomevrEdqCBq8vS5uCRUeeDZNKr5GD2mPs1ea620Oi_AIhMMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/welcome.vue?macro=true";
import { default as index95xE_h32YttieRoztLJvLk4_457QnuSEEDQ1PtlRkTXEIMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings/index.vue?macro=true";
import { default as users84tXH_P_45Y4UmuecMdxkHdoqEvzOKzV5HmePX6c3SOlIMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings/users.vue?macro=true";
import { default as billingBZAV8IItnEcMzvYN9IiEsnPKTJ1dIA7xaghBb5fhCLcMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings/billing.vue?macro=true";
import { default as profileJbWDBXW46XurTW5ee54eOZDT0ZRNGSvy29xz6aRNni0Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings/profile.vue?macro=true";
import { default as companiesynm_X1h67I4_ysRKMJVbHgN9NX0lLV3FG6IAW0__zUcMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings/companies.vue?macro=true";
import { default as organization_Bfb5EBkl4BYwqUBd437sb8t35i3r_45JNZPUVxPFxyqUMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings/organization.vue?macro=true";
import { default as settingsUbGpikLFXdDii2g9r3OmuinspUoELTgqzHD2YE_45wZVwMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/settings.vue?macro=true";
import { default as no_45accesso54_REJOSYOQn_PBdd0YRyrX3rRjPfyqThuLoXZVtmEMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/no-access.vue?macro=true";
import { default as select_45plan2VjaLnMEtjFC4vw5GGrk6EAo9qd7VAQPv8xXrij4XM0Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/select-plan.vue?macro=true";
import { default as payment_45success128G3xl1bxRzlTHGz06b6AG96CvZbiXowF6_7fu3PqYMeta } from "/opt/buildhome/repo/src/pages/(payment)/payment-success.vue?macro=true";
import { default as indexYLZ_45JsMHqieF3YyQzKfcbelTEoSb23otGgY1KCfXLbYMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/index.vue?macro=true";
import { default as indexoWY7Kea3lLDOZ3pVOITEN_uwz781ld7dlmo0imDCZ48Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/index.vue?macro=true";
import { default as indexA1gauqf1eR_13t2zTEwwqA1XXRW35cgfZtaPNuVdyLYMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/index.vue?macro=true";
import { default as indexCGK4VcqzG5xbxIzv9HO0WBSjYf4lLA0t92kMIp0rUF8Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/fsd/index.vue?macro=true";
import { default as indexQg2emTJPtUhR_tK45Fc_45GxRSCHLm3JAKhr05qySqurYMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/fsd/edit/index.vue?macro=true";
import { default as uploadCW3hFLcLni_FSAgwC1ryDT9b8Ef42HZp8lF2INLkVUoMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/comp/[compId]/upload.vue?macro=true";
import { default as indexj_ZtnDc5WuD6DS2KysZOxuewDd9HWe5mhkgP6Lx5hzcMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/fsd/confirm/index.vue?macro=true";
import { default as indexi9H5NWxWYNFM3LDqyn4LS0zg6ehY8uHDyMGHxeufXL8Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/comp/[compId]/mapping/edit/index.vue?macro=true";
import { default as indexlOcQFuggd4ZIA6SP97JFruaNrs7XZOthcek1bsRqIugMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/comp/[compId]/mapping/confirm/index.vue?macro=true";
import { default as data_45management7o6C3XZitxl9SBpxorgDWnUMNBzkoEonn1KN6Boct6QMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/data-management.vue?macro=true";
import { default as upload1dygzH6BeoOKYslP1XohT_45rQwsa_45lHKP0ikjF4zgj94Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/upload.vue?macro=true";
import { default as completeCJb5xsp1rk1IC3T7ibaVL5Ij29UT9TbHHuCuBjYS3MoMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/complete.vue?macro=true";
import { default as edit5SgHjp9iK72G774i5T4V2M7kvSn3fGwZZBFCszfxQiUMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/fsd/edit.vue?macro=true";
import { default as confirmF9vnGAvAfT6F24qJwFTW_45dyJHJi90gU0YeVuP3PKKvYMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/fsd/confirm.vue?macro=true";
import { default as edithmwT_45TvXJ3Qq245Z_PnCzKat59IqlDeLPF6zXKBoOR8Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/mapping/edit.vue?macro=true";
import { default as indexit4AGST2bqlJcegNmxYOcRailIW6qZXQ0mCQWbI1b_45sMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/plan/index.vue?macro=true";
import { default as confirmWw3pWzGski216A89mnj6F8hzSc6n53iGwKom0awU3hkMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/mapping/confirm.vue?macro=true";
import { default as indexTdBgtHUGSinWaYaXWP8ivDUecbATvAreDnjikEXL1F0Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/analysis/index.vue?macro=true";
import { default as index1YR8tAuKt48SMyA0VP9_45ykgnIpJDyZMFvCUq_OryIOUMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/dashboard/index.vue?macro=true";
import { default as indext1OEc8pM52vOdoxkt595ypvzfmR9GnP3duag4eyHsgQMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/financials/index.vue?macro=true";
import { default as _91fstmt_view_93k59HoKUL1iwMGpulwtXNdd5BDTtaiaTnAdDEYDEUXOcMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/plan/[display_mode]/[fstmt_view].vue?macro=true";
import { default as _91fstmt_view_939rqyBdrC6IF_459PdPr_dQLDFh_xZgSnUAGPZh79GYCxUMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/analysis/[display_mode]/[fstmt_view].vue?macro=true";
import { default as _91fstmt_view_93WaCKIshtXm5NbbEo5y0PkdTBHybgFtoyWRVvNJ6pkHUMeta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/financials/[display_mode]/[fstmt_view].vue?macro=true";
import { default as _91period_93oJoHZlT3AdpN_455uBnNWS9EJ_tpNIMJQmA9xh6WPvWd4Meta } from "/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/dashboard/[comparison]/[delta]/[period].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexL6IBblXwOeGe20PFY6CEA_XHd4mNKrrU5AlHwcK4aA4Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/index.vue")
  },
  {
    name: "org",
    path: "/org",
    meta: index2FtpexvyzCR_jxsFFz5u3XhooZijysjO8DpD1jDDDoYMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/index.vue")
  },
  {
    name: "org-new",
    path: "/org/new",
    meta: indexgNqYemAmWBNpVln1tbm4j13HGAY4e0owt2O6Jr5vbIEMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/new/index.vue")
  },
  {
    name: "enter-otp",
    path: "/enter-otp",
    meta: enter_45otpOI9x_45BBqYA3XkwV_yzRjg_FjQTsQndEKO78xghrQTlAMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/(auth)/enter-otp.vue")
  },
  {
    name: "org-orgId",
    path: "/org/:orgId()",
    meta: index7USUT2FsTWWZsQX4daVKdiby0TVI9ngKrVH_45zk0D3akMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/index.vue")
  },
  {
    name: "enter-email",
    path: "/enter-email",
    meta: enter_45emailq6r6TrDl_45BtMcy2jgG_45aYbyO8d2VjOWt2VZxERqZKKUMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/(auth)/enter-email.vue")
  },
  {
    name: "org-orgId-welcome",
    path: "/org/:orgId()/welcome",
    meta: { ...(welcomevrEdqCBq8vS5uCRUeeDZNKr5GD2mPs1ea620Oi_AIhMMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/welcome.vue")
  },
  {
    name: settingsUbGpikLFXdDii2g9r3OmuinspUoELTgqzHD2YE_45wZVwMeta?.name,
    path: "/org/:orgId()/settings",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings.vue"),
    children: [
  {
    name: "org-orgId-settings",
    path: "",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings/index.vue")
  },
  {
    name: "org-orgId-settings-users",
    path: "users",
    meta: users84tXH_P_45Y4UmuecMdxkHdoqEvzOKzV5HmePX6c3SOlIMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings/users.vue")
  },
  {
    name: "org-orgId-settings-billing",
    path: "billing",
    meta: billingBZAV8IItnEcMzvYN9IiEsnPKTJ1dIA7xaghBb5fhCLcMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings/billing.vue")
  },
  {
    name: "org-orgId-settings-profile",
    path: "profile",
    meta: profileJbWDBXW46XurTW5ee54eOZDT0ZRNGSvy29xz6aRNni0Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings/profile.vue")
  },
  {
    name: "org-orgId-settings-companies",
    path: "companies",
    meta: companiesynm_X1h67I4_ysRKMJVbHgN9NX0lLV3FG6IAW0__zUcMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings/companies.vue")
  },
  {
    name: "org-orgId-settings-organization",
    path: "organization",
    meta: organization_Bfb5EBkl4BYwqUBd437sb8t35i3r_45JNZPUVxPFxyqUMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/settings/organization.vue")
  }
]
  },
  {
    name: "org-orgId-no-access",
    path: "/org/:orgId()/no-access",
    meta: no_45accesso54_REJOSYOQn_PBdd0YRyrX3rRjPfyqThuLoXZVtmEMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/no-access.vue")
  },
  {
    name: "org-orgId-select-plan",
    path: "/org/:orgId()/select-plan",
    meta: { ...(select_45plan2VjaLnMEtjFC4vw5GGrk6EAo9qd7VAQPv8xXrij4XM0Meta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/select-plan.vue")
  },
  {
    name: "payment-success",
    path: "/payment-success",
    meta: payment_45success128G3xl1bxRzlTHGz06b6AG96CvZbiXowF6_7fu3PqYMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/(payment)/payment-success.vue")
  },
  {
    name: data_45management7o6C3XZitxl9SBpxorgDWnUMNBzkoEonn1KN6Boct6QMeta?.name,
    path: "/org/:orgId()/data-management",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management.vue"),
    children: [
  {
    name: "org-orgId-data-management",
    path: "",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/index.vue")
  },
  {
    name: "org-orgId-data-management-companies",
    path: "companies",
    meta: indexoWY7Kea3lLDOZ3pVOITEN_uwz781ld7dlmo0imDCZ48Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/index.vue")
  },
  {
    name: "org-orgId-data-management-organization",
    path: "organization",
    meta: indexA1gauqf1eR_13t2zTEwwqA1XXRW35cgfZtaPNuVdyLYMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/index.vue")
  },
  {
    name: "org-orgId-data-management-organization-fsd",
    path: "organization/fsd",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/fsd/index.vue")
  },
  {
    name: "org-orgId-data-management-organization-fsd-edit",
    path: "organization/fsd/edit",
    meta: indexQg2emTJPtUhR_tK45Fc_45GxRSCHLm3JAKhr05qySqurYMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/fsd/edit/index.vue")
  },
  {
    name: "org-orgId-data-management-companies-comp-compId-upload",
    path: "companies/comp/:compId()/upload",
    meta: uploadCW3hFLcLni_FSAgwC1ryDT9b8Ef42HZp8lF2INLkVUoMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/comp/[compId]/upload.vue")
  },
  {
    name: "org-orgId-data-management-organization-fsd-confirm",
    path: "organization/fsd/confirm",
    meta: indexj_ZtnDc5WuD6DS2KysZOxuewDd9HWe5mhkgP6Lx5hzcMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/organization/fsd/confirm/index.vue")
  },
  {
    name: "org-orgId-data-management-companies-comp-compId-mapping-edit",
    path: "companies/comp/:compId()/mapping/edit",
    meta: indexi9H5NWxWYNFM3LDqyn4LS0zg6ehY8uHDyMGHxeufXL8Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/comp/[compId]/mapping/edit/index.vue")
  },
  {
    name: "org-orgId-data-management-companies-comp-compId-mapping-confirm",
    path: "companies/comp/:compId()/mapping/confirm",
    meta: indexlOcQFuggd4ZIA6SP97JFruaNrs7XZOthcek1bsRqIugMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/data-management/companies/comp/[compId]/mapping/confirm/index.vue")
  }
]
  },
  {
    name: "org-orgId-onboarding-upload",
    path: "/org/:orgId()/onboarding/upload",
    meta: { ...(upload1dygzH6BeoOKYslP1XohT_45rQwsa_45lHKP0ikjF4zgj94Meta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/upload.vue")
  },
  {
    name: "org-orgId-onboarding-complete",
    path: "/org/:orgId()/onboarding/complete",
    meta: { ...(completeCJb5xsp1rk1IC3T7ibaVL5Ij29UT9TbHHuCuBjYS3MoMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/complete.vue")
  },
  {
    name: "org-orgId-onboarding-fsd-edit",
    path: "/org/:orgId()/onboarding/fsd/edit",
    meta: { ...(edit5SgHjp9iK72G774i5T4V2M7kvSn3fGwZZBFCszfxQiUMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/fsd/edit.vue")
  },
  {
    name: "org-orgId-onboarding-fsd-confirm",
    path: "/org/:orgId()/onboarding/fsd/confirm",
    meta: { ...(confirmF9vnGAvAfT6F24qJwFTW_45dyJHJi90gU0YeVuP3PKKvYMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/fsd/confirm.vue")
  },
  {
    name: "org-orgId-onboarding-mapping-edit",
    path: "/org/:orgId()/onboarding/mapping/edit",
    meta: { ...(edithmwT_45TvXJ3Qq245Z_PnCzKat59IqlDeLPF6zXKBoOR8Meta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/mapping/edit.vue")
  },
  {
    name: "org-orgId-comp-compId-plan",
    path: "/org/:orgId()/comp/:compId()/plan",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/plan/index.vue")
  },
  {
    name: "org-orgId-onboarding-mapping-confirm",
    path: "/org/:orgId()/onboarding/mapping/confirm",
    meta: { ...(confirmWw3pWzGski216A89mnj6F8hzSc6n53iGwKom0awU3hkMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/onboarding/mapping/confirm.vue")
  },
  {
    name: "org-orgId-comp-compId-analysis",
    path: "/org/:orgId()/comp/:compId()/analysis",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/analysis/index.vue")
  },
  {
    name: "org-orgId-comp-compId-dashboard",
    path: "/org/:orgId()/comp/:compId()/dashboard",
    meta: index1YR8tAuKt48SMyA0VP9_45ykgnIpJDyZMFvCUq_OryIOUMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/dashboard/index.vue")
  },
  {
    name: "org-orgId-comp-compId-financials",
    path: "/org/:orgId()/comp/:compId()/financials",
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/financials/index.vue")
  },
  {
    name: "org-orgId-comp-compId-plan-display_mode-fstmt_view",
    path: "/org/:orgId()/comp/:compId()/plan/:display_mode()/:fstmt_view()",
    meta: _91fstmt_view_93k59HoKUL1iwMGpulwtXNdd5BDTtaiaTnAdDEYDEUXOcMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/plan/[display_mode]/[fstmt_view].vue")
  },
  {
    name: "org-orgId-comp-compId-analysis-display_mode-fstmt_view",
    path: "/org/:orgId()/comp/:compId()/analysis/:display_mode()/:fstmt_view()",
    meta: { ...(_91fstmt_view_939rqyBdrC6IF_459PdPr_dQLDFh_xZgSnUAGPZh79GYCxUMeta || {}), ...{"middleware":["analysis-display-mode"]} },
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/analysis/[display_mode]/[fstmt_view].vue")
  },
  {
    name: "org-orgId-comp-compId-financials-display_mode-fstmt_view",
    path: "/org/:orgId()/comp/:compId()/financials/:display_mode()/:fstmt_view()",
    meta: _91fstmt_view_93WaCKIshtXm5NbbEo5y0PkdTBHybgFtoyWRVvNJ6pkHUMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/financials/[display_mode]/[fstmt_view].vue")
  },
  {
    name: "org-orgId-comp-compId-dashboard-comparison-delta-period",
    path: "/org/:orgId()/comp/:compId()/dashboard/:comparison()/:delta()/:period()",
    meta: _91period_93oJoHZlT3AdpN_455uBnNWS9EJ_tpNIMJQmA9xh6WPvWd4Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/org/[orgId]/comp/[compId]/dashboard/[comparison]/[delta]/[period].vue")
  }
]